import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTable, useRowSelect } from "react-table";
import { fetchDeletedLineItems, restoreDeletedAllLineItems, restoreDeletedLineItems } from "../../services/api/apiHandler";
import SuccessPopup from "../../myfin_v2/elements/SuccessPopup";
import ErrorPopup from "../../myfin_v2/elements/ErrorPopup";
import { fetchConventionalMode, restoreLineItems, restoreMultiLineItems } from "../../redux/actions/TemplateTabs/actionCM";
import { deletedColumn } from "../../Components/deletedItems/deletedColumn";
import commoncss from "../../myfin_v2/css/common.module.css";
import buttoncss from "../../myfin_v2/css/button.module.css";
import tablecss from "../../myfin_v2/css/table.module.css";
import { Button } from "../../myfin_v2/elements/Button";
import { ReactComponent as LeftIcon } from "../../myfin_v2/assets/icons/left_arrow.svg";
import { ReactComponent as SearchIcon } from "../../myfin_v2/assets/icons/searchPri.svg";
import { ReactComponent as FilterIcon } from "../../myfin_v2/assets/icons/filter.svg";
import { ReactComponent as CloseIcon } from "../../myfin_v2/assets/icons/close.svg";
import RestorePopup from "../../myfin_v2/elements/RestorePopup";
import emptyState from "../../myfin_v2/assets/icons/Empty.svg";
import Breadcrumb from "../../myfin_v2/components/Breadcrumb";
import { getPopulateFSDeletedItemsApiHandler, restorePopulateFSDeletedItemsApiHandler } from "../../WorkSpace/Components/ApiServices/apiHandler";
import { ReactComponent as RestoreIcon } from "../../myfin_v2/assets/icons/repeatIcon.svg";
import arrowRightIcon from "../../myfin_v2/assets/icons/arrowRight.png";
import infoGreyIcon from "../../myfin_v2/assets/icons/infoGrey.svg";
import { genId, normalizeFromInitial, cleanTableData, getSectionFromDeletedItem, getTabFromDeletedItem, getTitleFromDeletedItem } from "./DeletedFSHelpers";
import RetryIcon from "../../myfin_v2/assets/icons/Retry.png";
import Checkmark from "../../myfin_v2/assets/icons/Check(circle).png";

const DeletedItemsPage = ({ onClose }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { pid } = useParams();
  const [selectedRowIds, setSelectedRowIds] = useState({});
  
  const [activeTab, setActiveTab] = useState("Ledger");
  const [activeSubTab, setActiveSubTab] = useState("Level 1");

  // FS Deleted Items State
  const [apiDeletedItems, setApiDeletedItems] = useState([]);
  const [selectedFSItems, setSelectedFSItems] = useState([]);

  const [deletedRow, setDeletedRow] = useState({
    loading: false,
    isSuccess: false,
    response: [],
    error_message: ""
  });
  const [delRows, setDelRows] = useState([]);
  const tb_id = useSelector((state) => state.reducer.tb_id) || localStorage.getItem("tb_id");
  const project_id = pid || localStorage.getItem("project_id");
  const user = JSON.parse(localStorage.getItem("user"));
  const workspaceName = sessionStorage.getItem("adj_workspace_name") || localStorage.getItem("workspaceName") || "Workspace";
  const standaloneName = sessionStorage.getItem("adj_standalone_name") || "Standalone Financial Statements";
  
  const [showRestoreConfirm, setShowRestoreConfirm] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [successMessage, setSuccessMessage] = useState("Restored Successfully");
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [restoreConfirmData, setRestoreConfirmData] = useState(null);

  useEffect(() => {
    setSelectedFSItems([]);
    if (activeTab === "Ledger") {
      fetchData();
    } else if (activeTab === "Balance Sheet" || activeTab === "P&L Statement") {
      refreshFSDeletedItems();
    }
  }, [activeTab, activeSubTab]);

  const fetchData = () => {
    setDeletedRow({ ...deletedRow, loading: true });
    fetchDeletedLineItems(project_id, tb_id)
      .then((response) => {
        setDeletedRow({
          ...deletedRow,
          isSuccess: true,
          loading: false,
          response: response.data.deleted_items
        });
        setDelRows(response.data.deleted_items.map((row) => row.item));
      })
      .catch((err) => {
        setDeletedRow({
          ...deletedRow,
          isSuccess: false,
          loading: false,
          error_message: err.message
        });
      });
  };

  const refreshFSDeletedItems = () => {
    if (!project_id) return Promise.resolve();

    return getPopulateFSDeletedItemsApiHandler({ projectID: project_id })
      .then((res) => {
        if (res?.data?.success || res?.data?.data) {
          const fetchedData = res.data.data || res.data.deletedItems || [];
          const flattenedData = [];

          const processItem = (item, parentDeletedId, parentCategory, accumulatedParents = []) => {
             const category = parentCategory || item.category || item.section || item.statementType || item.fsType;
             const baseParents = parentDeletedId ? accumulatedParents : (item.parentNames || []);
             flattenedData.push({
               ...item,
               category: category,
               isChild: !!parentDeletedId,
               hierarchyParents: baseParents,
               parentDeletedId: parentDeletedId
             });

             const currentName = item.name || item.title || "";
             const nextParents = [...baseParents, currentName];
             const nextParentId = parentDeletedId || item._id;

             if (item.data && item.data.node && Array.isArray(item.data.node.subgroup)) {
                 item.data.node.subgroup.forEach(child => processItem(child, nextParentId, category, nextParents));
             } else if (Array.isArray(item.subgroup)) {
                 item.subgroup.forEach(child => processItem(child, nextParentId, category, nextParents));
             }
          };

          fetchedData.forEach(item => processItem(item, null, null, []));

          let mapped = flattenedData.map((item, idx) => ({
            id: item._id, 
            uniqueKey: `${item._id}_${idx}`, 
            section: getSectionFromDeletedItem(item),
            tab: getTabFromDeletedItem(item),
            title: getTitleFromDeletedItem(item),
            levelLabel: getTabFromDeletedItem(item),
            hierarchyParents: item.hierarchyParents || [],
            isChild: !!item.isChild,
            noteData: item,
            isApiItem: true,
            rawItem: item,
          }));

          mapped = mapped.map(item => {
            if (item.isChild) return item;

            const safeCompare = (str1, str2) => {
              if (!str1 || !str2) return false;
              return str1.toString().trim().toLowerCase() === str2.toString().trim().toLowerCase();
            };

            let hasIndependentParent = false;
            if (item.tab === "Level 2") {
              hasIndependentParent = mapped.some(parent => 
                parent.tab === "Level 1" && 
                ((item.rawItem?.fsGroupID && parent.id === item.rawItem?.fsGroupID) || 
                 safeCompare(parent.title, item.rawItem?.fsGroupName) || safeCompare(parent.title, item.rawItem?.fs_grp) || safeCompare(parent.title, item.hierarchyParents?.[0]))
              );
            } else if (item.tab === "Level 3") {
              hasIndependentParent = mapped.some(parent => 
                (parent.tab === "Level 2" && 
                  ((item.rawItem?.noteGroupID && parent.id === item.rawItem?.noteGroupID) || 
                   safeCompare(parent.title, item.rawItem?.noteGroupName) || safeCompare(parent.title, item.rawItem?.note_grp) || safeCompare(parent.title, item.hierarchyParents?.[1] || item.hierarchyParents?.[item.hierarchyParents?.length - 1]))
                ) || 
                (parent.tab === "Level 1" && 
                  ((item.rawItem?.fsGroupID && parent.id === item.rawItem?.fsGroupID) || 
                   safeCompare(parent.title, item.rawItem?.fsGroupName) || safeCompare(parent.title, item.rawItem?.fs_grp) || safeCompare(parent.title, item.hierarchyParents?.[0]))
                )
              );
            }

            if (hasIndependentParent) {
              return { ...item, isChild: true };
            }
            return item;
          });

          setApiDeletedItems(mapped);
        }
      })
      .catch((err) => console.error("Error fetching FS deleted items", err));
  };

  const handleRestore = (row) => {
    if (user?.responsibilities === "approver" || user?.responsibilities === "view") {
      setErrorMessage("You Don't have access to restore"); setShowErrorPopup(true);
      return;
    }
    setRestoreConfirmData(row);
  };

  const IndeterminateCheckbox = React.forwardRef(({ indeterminate, ...rest }, ref) => {
    const defaultRef = React.useRef();
    const resolvedRef = ref || defaultRef;

    React.useEffect(() => {
      if (resolvedRef.current) {
        resolvedRef.current.indeterminate = indeterminate;
      }
    }, [resolvedRef, indeterminate]);

    return <input type="checkbox" ref={resolvedRef} {...rest} style={{ accentColor: '#2d8861', width: '16px', height: '16px' }} />;
  });

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    selectedFlatRows,
  } = useTable(
    {
      columns: deletedColumn,
      data: delRows,
    },
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        {
          id: "selection",
          Header: ({ getToggleAllRowsSelectedProps }) => (
            <div>
              <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
            </div>
          ),
          Cell: ({ row }) => (
            <div>
              <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
            </div>
          ),
        },
        ...columns,
      ]);
    }
  );

  const RestoreSelected = () => {
    if (!selectedFlatRows || selectedFlatRows.length === 0) return;
    const data = { deletedLineItems: selectedFlatRows.map((ele) => ele.original) };

    restoreDeletedAllLineItems(project_id, tb_id, data)
      .then(() => {
        dispatch(fetchConventionalMode(project_id, tb_id));
        dispatch(restoreMultiLineItems(project_id, tb_id));
        const newResultSet = deletedRow.response.filter(
          (item) => !selectedFlatRows.some((item2) => item2.original.lid === item.item.lid)
        );
        setDeletedRow({ ...deletedRow, response: newResultSet });
        setDelRows(newResultSet.map((row) => row.item));

        setShowSuccessPopup(true);
        setTimeout(() => {
          setShowSuccessPopup(false);
        }, 2000);
      })
      .catch((error) => {
        setErrorMessage(error.response?.data?.error || "Items Restore Failed!"); setShowErrorPopup(true);
      });
  };

  const formatIndianNumber = (val) => {
    if (val === null || val === undefined || isNaN(val) || val === "") return val;
    const num = Number(val);
    const formatted = Math.abs(num).toLocaleString("en-IN", { maximumFractionDigits: 2 });
    return num < 0 ? `(${formatted})` : formatted;
  };

  const getDisplayedFSItems = () => {
    const targetSection = activeTab === "Balance Sheet" ? "BS" : "PL";
    return apiDeletedItems.filter(di => di.section === targetSection && di.tab === activeSubTab);
  };

  const handleRestoreFSItem = (id) => {
    if (user?.responsibilities === "approver" || user?.responsibilities === "view") {
      setErrorMessage("You Don't have access to restore"); setShowErrorPopup(true);
      return;
    }
    restorePopulateFSDeletedItemsApiHandler({ projectID: project_id }, { deletedItemID: [id] })
      .then((res) => {
        if (res.data.success) {
          setSuccessMessage("Restored successfully"); setShowSuccessPopup(true);
          refreshFSDeletedItems();
        }
      })
      .catch((err) => {
        setErrorMessage(err.message || "Something went wrong"); setShowErrorPopup(true);
      });
  };

  const renderFSItems = () => {
    const displayedItems = getDisplayedFSItems();

    if (displayedItems.length === 0) {
      return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100%" }}>
          <img src={emptyState} alt="Empty State" width="240" height="100" />
          <span style={{ fontSize: "18px", fontWeight: "600", color: "#1A493B", marginTop: "16px" }}>Nothing here yet</span>
          <span style={{ color: "#4D6D64", marginTop: "8px" }}>There are no deleted items</span>
        </div>
      );
    }

    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', paddingBottom: '15px', borderBottom: '1px solid #eaeeed', marginBottom: '15px' }}>
          <input 
            type="checkbox" 
            checked={displayedItems.length > 0 && selectedFSItems.length === displayedItems.length}
            onChange={(e) => {
              if (e.target.checked) {
                setSelectedFSItems(displayedItems.map(di => di.id));
              } else {
                setSelectedFSItems([]);
              }
            }}
            style={{ accentColor: '#205a46', width: '16px', height: '16px' }} 
          />
          <span style={{ fontSize: '14px', fontWeight: 500, color: '#333' }}>
            Select All
          </span>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
          {displayedItems.map((di) => (
            <div key={di.uniqueKey} style={{ display: 'flex', alignItems: 'flex-start', padding: '15px 0', borderBottom: '1px solid #eaeeed' }}>
              <div style={{ marginTop: '2px', opacity: di.isChild ? 0.6 : 1, marginRight: '15px' }}>
                <input 
                  type="checkbox" 
                  checked={selectedFSItems.includes(di.id)}
                  onChange={(e) => {
                    if (di.isChild) {
                      const parentLevel = di.tab === 'Level 3' ? 'level 2' : 'level 1';
                      setErrorMessage(`No ${parentLevel} to restore to. ${parentLevel.charAt(0).toUpperCase() + parentLevel.slice(1)} has been deleted`); setShowErrorPopup(true);
                      return;
                    }
                    if (e.target.checked) {
                      setSelectedFSItems(prev => [...new Set([...prev, di.id])]);
                    } else {
                      setSelectedFSItems(prev => prev.filter(item => item !== di.id));
                    }
                  }}
                  style={{ accentColor: '#205a46', width: '16px', height: '16px', cursor: di.isChild ? 'not-allowed' : 'pointer' }} 
                />
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '15px' }}>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <div style={{ fontSize: '15px', fontWeight: 400, color: '#111111', opacity: di.isChild ? 0.6 : 1 }}>
                        {di.title}
                      </div>
                      {di.isChild && (
                        <div className="bin-child-tooltip-container">
                          <img src={infoGreyIcon} alt="info" style={{ width: '16px', height: '16px', cursor: 'pointer' }} />
                          <span className="bin-child-tooltip">
                            No {di.tab === 'Level 3' ? 'level 2' : 'level 1'} to restore to.<br />
                            {di.tab === 'Level 3' ? 'Level 2' : 'Level 1'} has been deleted
                          </span>
                        </div>
                      )}
                    </div>
                    {di.hierarchyParents && di.hierarchyParents.length > 0 ? (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '8px', flexWrap: 'wrap', opacity: di.isChild ? 0.6 : 1 }}>
                        {di.hierarchyParents.map((parentName, parentIdx) => (
                          <React.Fragment key={parentIdx}>
                            <div style={{
                              display: 'flex', alignItems: 'center', gap: '6px',
                              padding: '2px 8px', borderRadius: '4px',
                              background: '#f4faf5', border: '1px solid #c2e6d1'
                            }}>
                              <span style={{ fontSize: '12px', fontWeight: 600, color: '#809790' }}>
                                LV{parentIdx + 1}
                              </span>
                              <span style={{ fontSize: '13px', fontWeight: 500, color: '#152521' }}>
                                {parentName}
                              </span>
                            </div>
                            {parentIdx < di.hierarchyParents.length - 1 && (
                              <img src={arrowRightIcon} alt="arrow" style={{ width: '12px', height: '12px', objectFit: 'contain' }} />
                            )}
                          </React.Fragment>
                        ))}
                      </div>
                    ) : (
                      <div style={{ fontSize: '13px', color: '#4D6D64', marginTop: '4px' }}>
                        {di.levelLabel}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div style={{ fontFamily: "'DM Sans', sans-serif", background: "transparent", margin: "10px 20px 20px 20px", height: "calc(100vh - 40px)", display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <style>
        {`
          .bin-child-tooltip-container {
            position: relative;
            display: inline-flex;
            align-items: center;
          }
          .bin-child-tooltip {
            visibility: hidden;
            background-color: #111111;
            color: #fff;
            text-align: center;
            border-radius: 4px;
            padding: 8px 12px;
            position: absolute;
            z-index: 10;
            top: 50%;
            left: 100%;
            transform: translateY(-50%);
            margin-left: 10px;
            opacity: 0;
            transition: opacity 0.3s;
            white-space: nowrap;
            font-size: 13px;
            box-shadow: 0px 4px 10px rgba(0,0,0,0.25);
          }
          .bin-child-tooltip::after {
            content: "";
            position: absolute;
            top: 50%;
            right: 100%;
            margin-top: -5px;
            border-width: 5px;
            border-style: solid;
            border-color: transparent #111111 transparent transparent;
          }
          .bin-child-tooltip-container:hover .bin-child-tooltip {
            visibility: visible;
            opacity: 1;
          }
          .custom-breadcrumb {
            background-color: transparent !important;
            height: auto !important;
            padding: 0 !important;
            margin-right: auto;
          }
          .hide-scrollbar::-webkit-scrollbar {
            display: none;
          }
          .hide-scrollbar {
            -ms-overflow-style: none;
            scrollbar-width: none;
          }
        `}
      </style>
      {/* Header bar OUTSIDE the white container */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0 0 20px 0" }}>
        <div style={{ display: "flex", alignItems: "center", flex: 1 }}>
          <LeftIcon
            height={13}
            width={13}
            style={{ transform: "translateY(1px)" }}
            className="clickable mr-2"
            onClick={onClose ? onClose : () => history.push(`/templateV2/${project_id}`)}
          />
          <Breadcrumb
            hideArrow={true}
            addCls="custom-breadcrumb"
            items={[
              {
                label: workspaceName,
                link: localStorage.getItem("ws_id") ? `/financialstatement/${localStorage.getItem("ws_id")}` : `/${localStorage.getItem("templateAction")}/${project_id}`,
                className: `${commoncss.nav_cnt_color} clickable`,
              },
              {
                label: standaloneName,
                link: localStorage.getItem("ws_id") ? `/templateV2/${project_id}` : `/${localStorage.getItem("templateAction")}/${project_id}`,
                className: `${commoncss.nav_cnt_color} clickable`,
              },
              {
                label: "Mapping Page",
                link: `/templateV2/${project_id}`,
                className: `${commoncss.nav_cnt_color} clickable`,
              },
              {
                label: "Deleted Items",
                link: "",
                className: "headerLable",
              },
              {
                label: activeTab,
                link: "",
                className: "headerLable",
              },
            ]}
            headerActions={<></>}
          />
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          {/* <SearchIcon style={{ width: "20px", height: "20px", cursor: "pointer", color: "#2d8861" }} />
          <FilterIcon style={{ width: "20px", height: "20px", cursor: "pointer", color: "#2d8861" }} /> */}
          {((activeTab === "Ledger" ? (selectedFlatRows?.length || 0) : selectedFSItems.length) > 0) && (
            <div style={{ fontSize: "14px", fontWeight: "600", color: "#183930" }}>
              ({activeTab === "Ledger" ? (selectedFlatRows?.length || 0) : selectedFSItems.length}) SELECTED
            </div>
          )}
          <button style={{ backgroundColor: "transparent", color: "#e30000", border: "1px solid #CCD5D3", padding: "8px 16px", borderRadius: "8px", fontSize: "13px", fontWeight: "500", cursor: "pointer" }}>
            Delete Permanently
          </button>
          <button
            onClick={() => {
              if (activeTab === "Ledger") {
                RestoreSelected();
              } else {
                if (selectedFSItems.length === 0) {
                  setErrorMessage("No items selected to restore"); setShowErrorPopup(true);
                  return;
                }
                restorePopulateFSDeletedItemsApiHandler({ projectID: project_id }, { deletedItemID: selectedFSItems })
                  .then((res) => {
                    if (res.data.success) {
                      setSuccessMessage("Restored selected items successfully"); setShowSuccessPopup(true);
                      setSelectedFSItems([]);
                      refreshFSDeletedItems();
                    }
                  })
                  .catch((err) => {
                    setErrorMessage(err.message || "Something went wrong"); setShowErrorPopup(true);
                  });
              }
            }}
            disabled={(activeTab === "Ledger" && (!selectedFlatRows || selectedFlatRows.length === 0)) || (activeTab !== "Ledger" && selectedFSItems.length === 0)}
            style={{
              backgroundColor: ((activeTab === "Ledger" && (!selectedFlatRows || selectedFlatRows.length === 0)) || (activeTab !== "Ledger" && selectedFSItems.length === 0)) ? "#a0c4b3" : "#205a46",
              color: "#fff", border: "none", padding: "8px 16px", borderRadius: "8px", fontSize: "13px", fontWeight: "500", cursor: "pointer"
            }}
          >
            Restore Selected Items
          </button>
          {activeTab === "Ledger" && (
            <button
               style={{ backgroundColor: "#205a46", color: "#fff", border: "none", padding: "8px 16px", borderRadius: "8px", fontSize: "13px", fontWeight: "500", cursor: "pointer" }}
               onClick={() => {
                 if (activeTab === "Ledger") {
                   setShowRestoreConfirm(true);
                 } else {
                   const displayed = getDisplayedFSItems();
                   const itemsToRestore = displayed.map(di => di.id);
                   if (itemsToRestore.length === 0) {
                     setErrorMessage("No items to restore"); setShowErrorPopup(true);
                     return;
                   }
                   restorePopulateFSDeletedItemsApiHandler({ projectID: project_id }, { deletedItemID: itemsToRestore })
                     .then((res) => {
                       if (res.data.success) {
                         setSuccessMessage("Restored all items successfully"); setShowSuccessPopup(true);
                         refreshFSDeletedItems();
                       }
                     })
                     .catch((err) => {
                       setErrorMessage(err.message || "Something went wrong"); setShowErrorPopup(true);
                     });
                 }
               }}
            >
              Restore All
            </button>
          )}
        </div>
      </div>

      {/* Main Content Area (White Container) */}
      <div style={{ flex: 1, background: "#fff", borderRadius: "14px", border: "1px solid #eaeeed", display: "flex", overflow: "hidden" }}>
          {/* Sidebar */}
          <div style={{ width: "220px", borderRight: "1px solid #eaeeed", display: "flex", flexDirection: "column", padding: "0" }}>
            {["Ledger", "Balance Sheet", "P&L Statement"].map((tab) => (
              <div
                key={tab}
                onClick={() => setActiveTab(tab)}
                style={{
                  padding: "15px 20px",
                  cursor: "pointer",
                  backgroundColor: activeTab === tab ? "#E4F2E6" : "#ffffff",
                  borderRight: activeTab === tab ? "1px solid #205a46" : "1px solid transparent",
                  color: activeTab === tab ? "#205a46" : "#111111",
                  fontWeight: activeTab === tab ? "600" : "500",
                  fontSize: "14px"
                }}
              >
                {tab}
              </div>
            ))}
          </div>

          {/* Table Content */}
          <div style={{ flex: 1, padding: "20px", display: "flex", flexDirection: "column" }}>
            <div style={{ flex: 1, display: "flex", flexDirection: "column", border: "1px solid #eaeeed", borderRadius: "8px", background: "#fff", overflow: "hidden" }}>
            {/* Optional Sub-tabs for BS and PL */}
            {(activeTab === "Balance Sheet" || activeTab === "P&L Statement") && (
              <div style={{ display: 'flex', borderBottom: '1px solid #eaeeed', background: '#ffffff' }}>
                {["Level 1", "Level 2", "Level 3"].map((tab) => (
                  <div 
                    key={tab}
                    onClick={() => setActiveSubTab(tab)}
                    style={{
                      padding: '16px 30px',
                      cursor: 'pointer',
                      fontSize: '14px',
                      fontWeight: activeSubTab === tab ? '600' : '500',
                      color: activeSubTab === tab ? '#205a46' : '#6b897e',
                      backgroundColor: activeSubTab === tab ? "#E4F2E6" : "transparent",
                      borderBottom: activeSubTab === tab ? '2px solid #205a46' : '2px solid transparent',
                      marginBottom: '-1px'
                    }}
                  >
                    {tab}
                  </div>
                ))}
              </div>
            )}

            <div className="hide-scrollbar" style={{ flex: 1, overflowY: "auto", padding: activeTab === "Ledger" ? "0 20px 20px 20px" : "20px" }}>
              {activeTab === "Ledger" ? (
                rows.length > 0 ? (
                  <table className={tablecss.customTable} {...getTableProps()} style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead style={{ backgroundColor: "#f4faf5", position: "sticky", top: 0, zIndex: 1 }}>
                      {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                          {headerGroup.headers.map((column) => {
                        const headerText = column.render("Header");
                        const isSelection = column.id === "selection";
                        const isAction = headerText === "ACTION";
                        
                        let align = "center";
                        if (isSelection) align = "left";
                        else if (headerText === "LEDGER CODE" || headerText === "LEDGER NAME" || headerText === "BRANCH") align = "left";
                        else if (headerText === "Current YEAR" || headerText === "PREVIOUS YEAR" || isAction) align = "right";

                        return (
                          <th
                            {...column.getHeaderProps()}
                            style={{
                              padding: isSelection ? "12px 5px 12px 15px" : "12px 15px",
                              textAlign: align,
                              fontSize: "12px",
                              fontWeight: "600",
                              color: "#183930",
                              textTransform: "uppercase",
                              borderBottom: "1px solid #eaeeed",
                              width: isSelection ? "40px" : "auto"
                            }}
                          >
                            {!isAction && headerText}
                          </th>
                        );
                      })}
                    </tr>
                  ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                  {rows.map((row) => {
                    prepareRow(row);
                    return (
                      <tr {...row.getRowProps()} style={{ borderBottom: "1px solid #eaeeed" }}>
                        {row.cells.map((cell) => {
                          const headerText = cell.column.Header;
                          const isSelection = cell.column.id === "selection";
                          const isAction = headerText === "ACTION";

                          let align = "center";
                          if (isSelection) align = "left";
                          else if (headerText === "LEDGER CODE" || headerText === "LEDGER NAME" || headerText === "BRANCH") align = "left";
                          else if (headerText === "Current YEAR" || headerText === "PREVIOUS YEAR" || isAction) align = "right";

                          return (
                            <td
                              {...cell.getCellProps()}
                              style={{ 
                                padding: isSelection ? "12px 5px 12px 15px" : "12px 15px", 
                                textAlign: align, 
                                fontSize: "13px", 
                                color: "#333",
                                width: isSelection ? "40px" : "auto"
                              }}
                            >
                              {isSelection ? (
                                cell.render("Cell")
                              ) : isAction ? (
                                <RestoreIcon width={18} height={18} style={{ cursor: "pointer", color: "#2d8861" }} onClick={() => handleRestore(row.original)} />
                              ) : (headerText === "Current YEAR" || headerText === "PREVIOUS YEAR") ? (
                                formatIndianNumber(cell.value)
                              ) : (
                                cell.render("Cell")
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              ) : (
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100%" }}>
                  <img src={emptyState} alt="Empty State" width="240" height="100" />
                  <span style={{ fontSize: "18px", fontWeight: "600", color: "#1A493B", marginTop: "16px" }}>Nothing here yet</span>
                  <span style={{ color: "#4D6D64", marginTop: "8px" }}>There are no deleted items</span>
                </div>
              )
            ) : (
              renderFSItems()
            )}
              </div>
            </div>
          </div>
        </div>

      {showRestoreConfirm && (
        <div className={commoncss.overlay}>
          <div className={commoncss.confirmPopup}>
            <div className={commoncss.confirmHeader}>
              <span className={commoncss.closeIcon} onClick={() => setShowRestoreConfirm(false)}>
                <CloseIcon />
              </span>
            </div>
            <p className={commoncss.confirmTitle}>
              Do you want to <b>restore </b> all <strong>{rows.length}</strong> items?
            </p>
            <p className={commoncss.confirmSubText}>
              This action will restore all items to the active list
            </p>
            <div className={commoncss.confirmActions}>
              <button
                className={commoncss.confirmBtn}
                onClick={() => {
                  setShowRestoreConfirm(false);
                  // Trigger restore all logic
                }}
              >
                <img src={RetryIcon} alt="restore" style={{ marginRight: "6px" }} />
                Yes, Restore
              </button>
              <button className={commoncss.cancelBtn} onClick={() => setShowRestoreConfirm(false)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <SuccessPopup
        isOpen={showSuccessPopup}
        message={successMessage}
        onClose={() => setShowSuccessPopup(false)}
      />
      <ErrorPopup
        isOpen={showErrorPopup}
        message={errorMessage}
        onClose={() => setShowErrorPopup(false)}
      />

      <RestorePopup
        isOpen={restoreConfirmData !== null}
        title={<>Do you want to <span style={{ fontWeight: 700 }}>restore</span> this item?</>}
        message="This will restore the item from the bin"
        onConfirm={() => {
          if (!restoreConfirmData) return;
          const row = restoreConfirmData;
          setRestoreConfirmData(null);
          restoreDeletedLineItems(project_id, row)
            .then(() => {
              dispatch(fetchConventionalMode(project_id, tb_id));
              dispatch(restoreLineItems(row, project_id, tb_id));
              const newResultSet = deletedRow.response.filter((item) => item.item.lid !== row.lid);
              setDeletedRow({ ...deletedRow, response: newResultSet });
              setDelRows(newResultSet.map((r) => r.item));
              setSuccessMessage("Restored successfully"); setShowSuccessPopup(true);
            })
            .catch((err) => {
              setErrorMessage(err?.response?.data?.error || "Something went wrong"); setShowErrorPopup(true);
            });
        }}
        onCancel={() => setRestoreConfirmData(null)}
      />
    </div>
  );
};

export default DeletedItemsPage;
